export default "__VITE_ASSET__CoVaEnwO__"